module.exports = "<h1 mat-dialog-title>Paypal Zahlung</h1>\r\n<mat-dialog-content>\r\n    <div>\r\n        Vielen Dank für Ihre Bestellung!<br/>\r\n        Bitte begleichen Sie den Betrag mittels PayPal.\r\n        <span id=\"paypal-button\"></span>\r\n        {{'CHECKOUT.LC_DISCLAIMER'|translate}}\r\n    </div>\r\n</mat-dialog-content>\r\n<mat-dialog-actions>\r\n    <button mat-raised-button mat-dialog-close color=\"primary\">{{'LC_CLOSE'|translate}}\r\n    </button>\r\n</mat-dialog-actions>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/checkout/dialog/paypal/paypal.component.html
// module id = ./src/app/components/checkout/dialog/paypal/paypal.component.html
// module chunks = main